import { HttpService } from '@/data/http/http-service';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { ProjectTourGateway } from '@/domain/project-tour/gateways/project-tour.gateway';

import {
  getProjectsTourDtoSchema,
  getProjectTourDtoSchema,
} from './project-tour.dto.schema';
import { ProjectTourMapper } from './project-tour.mapper';

export class ApiProjectTourHttpGateway implements ProjectTourGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });

  async getAll(): Promise<ProjectTour[]> {
    const url = '/tours';
    const options = { params: { $limit: 1000 } };
    const response = await this.http.get(url, options);
    const result = getProjectsTourDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const projects: ProjectTour[] = result.data.data.map((x) =>
      ProjectTourMapper.dtoToEntity(x),
    );
    return projects;
  }

  async get(id: number): Promise<ProjectTour> {
    const url = `/tours/${id}`;
    const response = await this.http.get(url);
    const result = getProjectTourDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const project = ProjectTourMapper.dtoToEntity(result.data);
    return project;
  }

  async create(project: ProjectTour): Promise<void> {
    const url = '/tours';
    const data = ProjectTourMapper.entityToDto(project);
    const response = await this.http.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error on creation';
    }
  }

  async delete(id: number): Promise<void> {
    const url = `/tours/${id}`;
    const response = await this.http.delete(url);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on delete';
    }
  }

  async edit(project: ProjectTour): Promise<void> {
    const url = `/tours/${project.id}`;
    const data = ProjectTourMapper.entityToDto(project);
    const response = await this.http.patch(url, data);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on edition';
    }
  }
}
